module.exports = __webpack_public_path__ + "img/PL00114.ab896e1b.png";